import { useState, useEffect } from "react";
import api from "../services/api"; // Supondo que api seja uma instância do axios

const usePartners = (idProcedures) => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPartners = async () => {
      // Impede requisições desnecessárias
      if (!Array.isArray(idProcedures) || idProcedures.length === 0) {
        setPartners([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null); // limpa erro anterior

        const response = await api.post(
          "/api/suggestion/scheduling/affiliates",
          {
            procedure_id: idProcedures,
          }
        );

        if (response.status !== 200) {
          throw new Error(`Erro ao carregar parceiros: ${response.statusText}`);
        }

        setPartners(response.data || []);
      } catch (err) {
        setError(err.message || "Erro desconhecido");
        setPartners([]); // limpa em caso de erro
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, [idProcedures]);

  return { partners, loading, error };
};

export default usePartners;
